


















































import { message, IMessage, attachments as attachmentsUtility } from "@/utilities/index";
import attachmentCard from "@/Webchat/components/attachments/attachmentCard.vue";
import attachmentsViewer from "@/Webchat/components/attachments/attachmentsViewer.vue";
import cardCarousel from "./cardCarousel.vue";
import buttonTemplate from "./buttonTemplate.vue";
import linkPreview from "./linkPreview.vue";
import 'flickity-imagesloaded';

export default {
    props: {
        message: {
            type: Object,
            required: true,
            default() { return {}; }
        },
        prevMessage: {
            type: Object,
            required: true,
            default() { return {}; }
        },
        isFullScreen: {
            type: Boolean,
            required: false,
            default: false
        },
        selectedLang: {
            type: String,
            required: false,
            default: 'en'
        }
    },
    components: {
        attachmentCard,
        attachmentsViewer,
        cardCarousel,
        buttonTemplate,
        linkPreview
    },
    computed: {
        hasOneAttachment() {
            return this.hasAttachments(this.message) && this.attachments.length === 1;
        },
        messageContentComponents() {
            return this.mapMessageTextToComponents(this.message) || [];
        },
        messageSenderAvatar() {
            const operatorImage = this.$vstore.settings.state.channelSettings.operatorImage;
            return this.message.source?.toLowerCase() === 'bot' ? operatorImage : this.message.sender_picture;
        },
        isValidMessage() {
            return this.message.messaging_type !== 'metadata' && message.isValidMessage(this.message) && ((this.message.text != '' || (this.message.text == '' && this.message.source !== 'bot')));
        }
    },
    data() {
        return {
            showImageViewerOverlay: false,
            attachments: [],
            imagesToPreview: [],
            attachmentIndexToPreview: null,
            copySuccess: '',
            messageId: -1,
            linkTarget: "_blank",
            urlRegex: /(?:https?:\/\/|www\.)[^\s<]+/gi,
            aTagRegex: /<a\s+[^>]*href\s*=\s*["'][^"']*["'][^>]*>/i,
            emailRegex: /(?:[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x21\x23-\x5b]|\\[\x7f])*")@(?:(?:[\w](?:[\w]*[\w])?\.)+[\w](?:[\w]*[\w])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[\w]*[\w]:(?:[\x21-\x5a]|\\[\x7f])+)\])/
        };
    },
    mounted() {
        this.fetchAttachmentsMetadata();
        this.$emit("mounted");
    },
    methods: {
        isProductsList(msg: IMessage) {
            return message.isProductsList(msg);
        },
        isTextButton(msg: IMessage) {
            return message.isTextButton(msg);
        },
        onPostback(payload: any, title: string) {
            this.$emit("onPostback", payload, title);
        },
        disableScrolling() {
            const container = this.$el.querySelector("#webchat-container");
            if (!container) return;
            container.style.overflowY = 'hidden';
        },
        getMessageCardsFromAttachments(message: any) {
            if (message && message.tactfulAttachments.length > 0) {
                return message.tactfulAttachments[0].element;
            }
            return [];
        },
        async fetchAttachmentsMetadata() {
            const attachments = [];
            for (const attachment of (this.message?.tactfulAttachments || [])) {
                if (attachment.type === 'generic' || attachment.type === 'template') continue;
                let metadata = {};
                try {
                    metadata = await attachmentsUtility.getAttachment(attachment) || {};
                } catch {
                    metadata = {};
                }
                attachments.push({ ...attachment, metadata: metadata });
            }
            this.attachments = attachments;
        },
        showAttachment(selectedAttachmentIndex: number) {
            this.attachmentIndexToPreview = selectedAttachmentIndex;
            this.showImageViewerOverlay = true;
            this.imagesToPreview = this.attachments || [];
        },
        downloadAttachment() {
            if (!this.$refs['attachmentCardRef']) return;
            this.$refs['attachmentCardRef'][0]?.downloadAttachment();
        },
        formatMessageDate(time: string) {
            return message.formatMessageDate(time, this.selectedLang);
        },
        isSentByPrevMessageSender(msg: IMessage, prevMessage: IMessage) {
            return message.isSentByPrevMessageSender(msg, prevMessage);
        },
        hasAttachments(message: IMessage) {
            if (!message?.tactfulAttachments?.length) return false;
            return !message.tactfulAttachments.some((attachment) => attachment.type === 'generic' || attachment.type === 'template');
        },
        extractUrlFromMessage(message: any) {//extract urls from text and return them if exist
            if (this.urlRegex.test(message)) {
                // check first if its' not an email (we DON'T want to preview the email as a LINK)
                if (!this.emailRegex.test(message)) {
                    const matches = message.match(this.urlRegex);
                    if (matches && matches.length > 0) {
                        return matches[0];
                    }
                    return null;
                } else {
                    return null;
                }
            } else {
                return null;
            }

        },
        getFormattedMessage(msg: IMessage) {
            return this.isTextButton(msg) ? msg.attachment.payload.text : this.formatMsg(msg.text, msg.to);
        },
        formatMsgWithURLs(msg: string, msgSource: boolean) {
            let target = this.linkTarget;

            // Remove URLs within <a> tags while preserving them
            let linksWithinATags: string[] = [];
            msg = msg.replace(this.aTagRegex, (match, url) => {
                linksWithinATags.push(match);
                return `___URL_PLACEHOLDER_${linksWithinATags.length - 1}___`;
            });

            // Find remaining URLs and wrap them with <a> tags
            msg = msg.replace(this.urlRegex, (url) => {
                return (
                    `<a href="${message.checkUrlContainsHttp(url)}" target="${target}'" style="color: inherit; word-break: break-all;  text-decoration: underline;">` + url + "</a>"
                );
            });

            // Replace placeholders with original <a> tags
            msg = msg.replace(/___URL_PLACEHOLDER_(\d+)___/g, (match, index) => {
                return linksWithinATags[Number(index)];
            });
            return msg;
        },
        formatMsg(msg: string, msgSource: boolean) {
            if (!msg) return '';
            if (this.emailRegex.test(msg)) {
                return msg.replace(this.emailRegex, (email) => {
                    return (
                        `<a href="mailto: ${email}" style="color: inherit; word-break: break-all;  text-decoration: underline;">${email}</a>`
                    );
                });

            }
            return this.formatMsgWithURLs(msg, msgSource);
        }
    }
};
